/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignJustified = createReactComponent("align-justified", "IconAlignJustified", [
  ["path", { d: "M4 6l16 0", key: "svg-0" }],
  ["path", { d: "M4 12l16 0", key: "svg-1" }],
  ["path", { d: "M4 18l12 0", key: "svg-2" }]
]);

export { IconAlignJustified as default };
//# sourceMappingURL=IconAlignJustified.js.map
